import ReassuranceSection from '@/components/shared/reassurance';
import { SEOProps } from '@/components/ui/SEO';
import { basePath } from '@/utils/basePath';
import ComparisonTable from '@/features/tarif/comparison-table';
import Cta from '@/features/tarif/cta';
import Hero from '@/features/tarif/hero';
import HowItWorks from '@/features/tarif/how-it-works';
import Plans from '@/features/tarif/plans';

const TARIF_SEO: SEOProps = {
  title: 'Tarifs | zLawyer',
  description:
    'Découvrez les offres zLawyer : 49€/mois/utilisateur pour les cabinets, 17€/mois pour les collaborateurs déjà sur zLawyer.',
  url: `https://www.zlawyer.fr${basePath}/tarif/`,
};

export default function TarifPage() {
  return (
    <>
      <Hero />
      <Plans />
      <HowItWorks />
      <ComparisonTable />
      <section className="max-width-white-section" id="tarif-reassurance">
        <div className="max-width-white-section-content py-0! pb-20!">
          <ReassuranceSection />
        </div>
      </section>
      <Cta />
    </>
  );
}

TarifPage.seo = TARIF_SEO;
